import { render, staticRenderFns } from "./svgRenderer.vue?vue&type=template&id=6f726b1f&lang=pug&"
import script from "./svgRenderer.vue?vue&type=script&lang=js&"
export * from "./svgRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports